module.exports = __webpack_public_path__ + "img/security1.281c5241.jpg";